<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="My Provident Fund"
                :btnTitle="'Add New'"
                :showAddNew="false"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
            </DateQuerySetter>
        </div>

        <div class="col-12">
          <div class="d-flex justify-content-end px-2">
            <button
                @click="goToPrint"
                :disabled="loading"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
            >
              Print
            </button>
          </div>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <ListTable :providentFundData="providentFundData" />
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import {inject, onMounted, reactive, ref} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleCompany from "@/services/modules/company";
import providentFundPdf from '@/services/utils/pdf/providentFundPdf';
import ListTable from '@/components/molecule/company/hrm-payroll/provident-fund/ListTable.vue';

const props = defineProps({
  contactInfo: {
    type: Object
  }
})

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const contactProfileData = ref('');
let contacts = ref([])
const providentFundData = ref({});
const params = ref({
    offset: 30,
});
let companyInfo = reactive({})
const token = computed(() => localStorage.getItem('token'));
const { exportToPDF } = providentFundPdf();
const {
  fetchProvidentFundData,
} = handleHrPayroll()
const { fetchCompanyInfo } = handleCompany();

const onClickToGo = () => {
   getProvidentFundList();
}
const getProvidentFundList = async () => {
    const query = getQuery();
    loading.value = true
    providentFundData.value = {}

    await fetchProvidentFundData(query).then(res => {
        if (!res.status){
            showError(res.message)
            return
        }

      providentFundData.value = res.data.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const goToPrint = async () => {
  const query = getQuery();
  loading.value = true;
  providentFundData.value = {};

  try {
    const res = await fetchProvidentFundData(query);

    if (!res.status) {
      showError(res.message);
      return;
    }

    providentFundData.value = res.data.data;
    contactProfileData.value = res.data.contact_profile;
    exportToPDF(companyInfo, providentFundData.value, contactProfileData.value);
  } catch (err) {
    console.log("Something went wrong");
  } finally {
    loading.value = false;
  }
}

const setCompanyInfo = async () => {
  await fetchCompanyInfo(route.params.companyId).then((res) => {
    companyInfo = res.data;
  }).catch((error) => {
    console.log(error);
  });
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}&is_my_pf=true`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    query += '&offset=' + params.value.offset
    return query;
}

onMounted(() => {
  setCompanyInfo()
})
</script>
